import React from "react";

const ProcessFollow = () => {
  return (
    <div className=" p-6 ">
      <div className="text-center max-w-6xl mx-auto">
        <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-4 text-gray-800">
          Workflow Methodology
        </h3>
        <p className="text-lg text-gray-600 max-w-5xl mx-auto">
          Our workflow methodology ensures seamless execution and delivery.
        </p>
        <div className="mt-10 p-4">
          <img
            src="/assets/images/process.png"
            alt="Workflow for large screens"
            className="hidden md:block mx-auto w-full max-w-6xl"
          />
          <img
            src="/assets/images/process1.png"
            alt="Workflow for mobile view"
            className="block md:hidden mx-auto w-full max-w-md p-4"
          />
        </div>
      </div>
    </div>
  );
};

export default ProcessFollow;
